/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./api";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const findOne = /* GraphQL */ `query FindOne($sapShipmentId: String!, $cartonNumber: String!) {
  findOne(sapShipmentId: $sapShipmentId, cartonNumber: $cartonNumber) {
    items {
      sapShipmentId
      cartonNumber
      billOfLading
      containerNumber
      sapDeliveryId
      sapPurchaseOrderItemNumber
      sapPurchaseOrderNumber
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.FindOneQueryVariables, APITypes.FindOneQuery>;
export const findShipmentsById = /* GraphQL */ `query FindShipmentsById($shipmentIds: [String!]!) {
  findShipmentsById(shipmentIds: $shipmentIds) {
    found {
      shipmentNumber
      containerNumber
      bolNumber
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindShipmentsByIdQueryVariables,
  APITypes.FindShipmentsByIdQuery
>;
